import React, { type ReactNode } from 'react';

// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import DeprecatedSpotlightTarget from '@atlaskit/onboarding/spotlight-target';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { PopoverTarget as AKPopoverTarget } from '@atlaskit/spotlight/popover-target';

export interface SpotlightTargetProps {
	/**
	 * A single child.
	 */
	children: ReactNode;
	/**
	 * The name to reference from Spotlight.
	 */
	name: string;
}

/**
 * __Spotlight target__
 *
 * A spotlight target marks a component to be used for introducing new features to users through focused messages or multi-step tours.
 *
 */
const SpotlightTarget: {
	({ children, name }: SpotlightTargetProps): React.JSX.Element;
	displayName: string;
} = ({ children, name }: SpotlightTargetProps): React.JSX.Element => {
	if (fg('ads_spotlight_migration_engagekit_ts')) {
		return <AKPopoverTarget>{children}</AKPopoverTarget>;
	}

	return <DeprecatedSpotlightTarget name={name}>{children}</DeprecatedSpotlightTarget>;
};

SpotlightTarget.displayName = 'SpotlightTarget';

export { SpotlightTarget };
